import type { PillColor } from '../../Pill'

export const mockOptions: { id: string; label: string; color: PillColor }[] = [
  { id: '1', label: 'Questionable', color: 'yellow' },
  { id: '2', label: 'False', color: 'red' },
  { id: '3', label: 'The Sky Is Blue', color: 'blue' },
  { id: '4', label: 'Pending Resolution', color: 'gray' },
  {
    id: '5',
    label: 'A very long STATUS that has to wrap cause it is so long',
    color: 'green',
  },
]
